import { useState } from 'react'
import { useGoogleLogin, CodeResponse } from '@react-oauth/google'
import { useQueryClient } from '@tanstack/react-query'

import { Button } from '@/components/Button'
import { Spinner } from '@/components/Spinner'
import { useToast } from '@/hooks/Toast'
import { useMe } from '@/hooks/useMe'
import { getDevice } from '@/utils/getDevice'
import { api } from '@/utils/api'
import googleLogo from '@/assets/google-logo.svg'

type Props = {
  children: React.ReactNode
  ref: string
  isLinkingAccount: boolean
  onSuccess?: () => void
}

export const GoogleLogin = ({
  children,
  ref,
  isLinkingAccount,
  onSuccess,
}: Props) => {
  const queryClient = useQueryClient()
  const toast = useToast()
  const [isLoading, setIsLoading] = useState(false)
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  useMe(isLoggedIn)

  const handleGoogleLoginSuccess = async (response: CodeResponse) => {
    try {
      setIsLoading(true)
      await api.post('/auth/login/google', {
        credential: response.code,
        linkAccount: isLinkingAccount,
        ref,
        device: getDevice(),
        referrer: document.referrer,
      })

      queryClient.invalidateQueries()
      setIsLoggedIn(true)
      onSuccess?.()
    } catch (error: any) {
      toast.error(
        error?.response?.data?.message ?? 'Something went wrong. Try again?'
      )
    } finally {
      setIsLoading(false)
    }
  }

  const handleGoogleLoginError = () => {
    toast.error('Something went wrong. Try again?')
    setIsLoading(false)
  }

  const googleLogin = useGoogleLogin({
    onSuccess: handleGoogleLoginSuccess,
    onError: handleGoogleLoginError,
    flow: 'auth-code',
  })

  return (
    // <GoogleLoginButton
    //   onSuccess={handleGoogleLoginSuccess}
    //   onError={handleGoogleLoginError}
    //   useOneTap={!isLinkingAccount && import.meta.env.PROD}
    //   shape="circle"
    //   auto_select
    // />
    <Button
      variant="secondary"
      iconRight={isLoading ? <Spinner inline /> : undefined}
      disabled={isLoading}
      onClick={() => googleLogin()}
    >
      <img src={googleLogo} width="14" alt="Google Logo" />
      {children}
    </Button>
  )
}
